if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        Button,
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-landing', {
        // built-in attributes
        title: 'Card Landing',
        description: 'Custom Card',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Pogledajte ponudu'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                title,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <div>
                                    { image && 
                                        <div>
                                            <figure>
                                                <img src={image} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ image: '' })} className="button">Remove</Button>
                                            </div>
                                        </div>
                                    }
                                    
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                                </div>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (primjer: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Link</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card card-page d-block border-0 text-decoration-none overflow-hidden mb-4">
                    <div class="card-img-top overflow-hidden rounded bg-dark w-100 position-relative">
                        <img class="cover-image h-100 w-100" src={ image } alt={ alt } />
                        {/* <div class="position-absolute bottom-0 bg-secondary small fw-bold text-white rounded px-3 py-1 m-2">
                            <RichText 
                                key="editable" 
                                tagName="span"
                                placeholder="RANI BOOKING" 
                                value={ tag }
                                onChange={ onTagChange } />
                        </div> */}
                    </div>
                    {/* <div class="card-body px-2">
                        <RichText 
                            key="editable" 
                            tagName="h4"
                            class="h5 text-uppercase mb-2"
                            placeholder="TITLE" 
                            value={ title }
                            onChange={ onTitleChange } />

                        <RichText 
                            key="editable" 
                            tagName="p"
                            class="summary-small small mb-2"
                            placeholder="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." 
                            value={ description }
                            onChange={ onDescriptionChange } />
                        <button class="w-100 btn btn-sm text-secondary p-0 d-flex justify-content-between align-items-center">
                            <RichText 
                                key="editable" 
                                tagName="span"
                                placeholder="Pogledajte ponudu" 
                                value={ viewMore }
                                onChange={ onViewMoreChange } />
                            <i class="las la-angle-double-right la-lg ms-2"></i>
                        </button>
                    </div> */}
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                tag,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <div className="overflow-hidden">
                    <a href={link } className={ "card card-category d-block border-0 bg-dark text-white text-decoration-none rounded overflow-hidden mb-3 mb-lg-0" }  style="height: 300px;">
                        <img className="lozad cover-image h-100 w-100" data-src={ image } alt={ alt } />
                        <div className="position-absolute bottom-0 left-0 right-0 card-body d-flex flex-column justify-content-end px-3 px-xl-4 py-4">
                            <div className="content">
                                <h4 className="card-title text-white text-shadow mb-3 mb-lg-2">{ title }</h4>
                                <button className="btn btn-sm btn-outline-warning text-white fw-bold text-uppercase">{ viewMore }</button>
                            </div>
                        </div>
                    </a>
                </div>
            ); 
        },
    });
}